module.exports = __webpack_public_path__ + "static/img/3.eb22f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/3.png
// module id = 8flg
// module chunks = 3